module.exports = __webpack_public_path__ + "img/testimonials-badge.29e61f2e.svg";